import { useEffect } from 'react';

import { useGroupActions } from './GroupContext';

import { getGroups } from './restApi';

const GroupLoader = () => {
  const { loadMoreGroupsOnResponse, onError } = useGroupActions();

  useEffect(() => {
    getGroups({
      lastPageViewed: 0,
      onResponse: loadMoreGroupsOnResponse,
      onError,
    });
  }, []);

  return null;
};

export default GroupLoader;
